import React, { Component } from 'react';
import { Button, Form, Input, message, Table, Card } from 'antd';
import { PostForm } from '../../utils/http';
import cn from './index.module.css';
import auth from '../../utils/auth'
import { AUTH } from '../../utils/menu'

class KLineSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hkdata: [],
      usdata: [],
      symbols: '',
      tableloading: false,
      subloading: false,
      unsubloading: false,
    };
  }
  componentDidMount() {
    this.getData();
  }
  getData = () => {
    this.setState({ tableloading: true });
    PostForm({
      url: '/api/kline/getSubscribedSymbols',
      data: {},
      success: ({ data }) => {
        this.setState({ hkdata: data.HK, usdata: data.US });
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
      final: () => {
        this.setState({ tableloading: false });
      },
    });
  }
  columns = [
    { title: '股票名称', dataIndex: 'name' },
    { title: '股票代码', dataIndex: 'symbol' },
  ]
  handleSymbole = (isSub) => {
    const { symbols } = this.state;
    const url = isSub ? '/api/kline/addSubscribeSymbols' : '/api/kline/removeSubscribeSymbols';
    const loading = isSub ? 'subloading' : 'unsubloading';
    this.setState({ [loading]: true });
    PostForm({
      url,
      data: { symbols },
      success: ({ msg = '操作成功' }) => {
        message.success(msg);
        this.getData();
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
      final: () => {
        this.setState({ [loading]: false });
      },
    });
  }
  render() {
    const { symbols, tableloading, subloading, unsubloading } = this.state;
    const isUS = auth.checkAuth([AUTH.US_KLINE.key]);
    return (
      <Card style={{ minHeight: '100vh' }}>
        <div>
          <Form.Item label="股票">
            <Input
              style={{ width: 300 }}
              value={symbols}
              onChange={e => this.setState({ symbols: e.target.value })}
              placeholder="请输入股票、多个分号分割"
            />
            <Button
              disabled={!symbols}
              type="primary"
              style={{ marginLeft: 20 }}
              loading={subloading}
              onClick={() => this.handleSymbole(true)}
            >订阅</Button>
            <Button
              disabled={!symbols}
              type="primary"
              style={{ marginLeft: 20 }}
              loading={unsubloading}
              onClick={() => this.handleSymbole(false)}
            >解订阅</Button>
          </Form.Item>
        </div>
        <div className={cn.table}>
          <Table
            size="small"
            loading={tableloading}
            dataSource={this.state.hkdata}
            columns={this.columns}
            pagination={{ pageSize: 10 }}
            rowKey="symbol"
          />
          {
            isUS && (
              <Table
                size="small"
                loading={tableloading}
                dataSource={this.state.usdata}
                columns={this.columns}
                pagination={{ pageSize: 10 }}
                rowKey="symbol"
              />
            )
          }
        </div>
      </Card>
    );
  }
}

export { KLineSubscription };
